/**
 * Types of errors that are likely to be chunk-related.
 */
export const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /Loading chunk \d+ failed/i,
]

/**
 * Types of errors that are likely to be analytcs related.
 */
export const BLOCKED_ANALYTICS_SCRIPT_PATTERNS = [
  /googletagmanager\.com/i,
  /next-integrations\/actions/i,
  /Failed to load.*gtag/i,
  /Failed to load Google Tag Manager/i,
]
